import { Box, Button, Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { applyServiceWorkerUpdate, onServiceWorkerUpdate } from 'utils/service-worker'

/**
 * An installed app can stay open for days, so it will happily keep running a build we
 * shipped weeks ago. The service worker downloads new versions in the background; this
 * lets the user decide when to swap over, rather than reloading mid-booking.
 */
export const AppUpdatePrompt = () => {
  const { formatMessage } = useIntl()
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)

  useEffect(() => onServiceWorkerUpdate(() => setUpdateAvailable(true)), [])

  if (!updateAvailable) {
    return null
  }

  return (
    <Box
      px={4}
      py={4}
      backgroundColor="purple.100"
      borderTopWidth="1px"
      borderTopColor="purple.300"
      aria-live="polite"
    >
      <Flex
        maxWidth="1184px"
        mx="auto"
        gap={4}
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text fontSize="sm" fontWeight="500">
          {formatMessage({
            id: 'pwa.update.available',
            defaultMessage: 'A new version of Wanda is available',
          })}
        </Text>
        <Button
          size="sm"
          colorScheme="purple"
          isLoading={isUpdating}
          data-testid="apply-app-update"
          onClick={() => {
            setIsUpdating(true)
            applyServiceWorkerUpdate()
          }}
        >
          {formatMessage({ id: 'pwa.update.action', defaultMessage: 'Update' })}
        </Button>
      </Flex>
    </Box>
  )
}
